import { adminComponent } from '../../../layout/layouts/admin.component';
import { Page401Component } from './page-error/page-401-component';
import { AuthGuard } from '../../../common/services/Auth.guard';
import { ChatComponent } from './chat/chat.component';
import { SearchComponent } from './search/search.component';
import { CampaignComponent } from './campaign/campaign.component';
import { CustomerComponent } from './customer/customer.component';
import { ReportComponent } from './report/report.component';
import { VideoCallComponent } from './video-call/video-call.component';
import { SettingsRoute } from './setting/settings.route';
import { MonitorsRoute } from './monitors/monitors.route';
import { SmartQcRoute } from './smart-qc/smart-qc.route';
import { ReportRoutev2 } from './reportv2/reportv2.route';

export const BASE_URL = 'search/ticket';

export const IContactRoute = [
  { path: '', redirectTo: 'search/ticket', pathMatch: 'full' },
  {
    path: '',
    component: adminComponent,
    children: [
      {
        path: 'chatting',
        redirectTo: '/chatting/all',
        pathMatch: 'full',
        canActivate: [AuthGuard],
        data: { role: ['administrator', 'supervisor', 'agent'] },
      },
      {
        path: 'page-401',
        component: Page401Component,
        canActivate: [AuthGuard],
      },
      {
        path: 'chatting/:type',
        component: ChatComponent,
        canActivate: [AuthGuard],
        data: { role: ['administrator', 'supervisor', 'agent'] },
      },
      {
        path: 'search/ticket',
        component: SearchComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'campaign',
        component: CampaignComponent,
        canActivate: [AuthGuard],
        data: { role: ['administrator', 'supervisor'] },
      },
      {
        path: 'customer',
        component: CustomerComponent,
        canActivate: [AuthGuard],
        data: { role: ['administrator', 'supervisor', 'agent', 'team_leader'] },
      },
      {
        path: 'video-call',
        component: VideoCallComponent,
        canActivate: [AuthGuard],
      },
      ...SettingsRoute,
      ...MonitorsRoute,
      ...SmartQcRoute,
      ...ReportRoutev2,
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/icontact.route.ts